import { render, staticRenderFns } from "./LiveList.vue?vue&type=template&id=d377990c&scoped=true"
import script from "./LiveList.vue?vue&type=script&lang=js"
export * from "./LiveList.vue?vue&type=script&lang=js"
import style0 from "./LiveList.vue?vue&type=style&index=0&id=d377990c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d377990c",
  null
  
)

export default component.exports